define(['morningstar', 'underscore', './date-helper'], function(morningstar, _, dateHelper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromMarkets', function(data) {
        var chartSettings = this.context.instance.model.chartSettings;
        if (!data || !data.Data || !chartSettings) {
            return;
        }
        var priceData = {};
        var priceTableData = getPriceTableData(data.Data, chartSettings);
        var priceChartData = getPriceChartData(data.Data, chartSettings);
        priceData = {
            priceTableData: priceTableData,
            priceChartData: priceChartData
        };
        return priceData;
    });

    function getPriceTableData(data, chartSettings) {
        var priceTableData = [];
        var asOfDate = chartSettings.comparisonFund.asOfDate ? _.max([chartSettings.comparisonFund.asOfDate, chartSettings.primaryFund.asOfDate]) : chartSettings.primaryFund.asOfDate;
        asOfDate = dateHelper.toDateObject(asOfDate);
        var inputStartDate = chartSettings.startDate;
        var inputEndDate = chartSettings.endDate;
        var startDate = '';
        var endDate = '';
        var dateList1 = data[0].DailyData.HS538;
        var dateList2 = data[1] ? data[1].DailyData.HS538 : '';
        var comparisonInceptionDate = chartSettings.comparisonFund.inceptionDate || '';
        var primaryInceptionDate = chartSettings.primaryFund.inceptionDate;
        var funds = chartSettings.comparisonFund.name ? [chartSettings.primaryFund, chartSettings.comparisonFund] : [chartSettings.primaryFund];
        if (dateList1.length > 0 && dateList2.length > 0) {
            startDate = _.max([inputStartDate, comparisonInceptionDate, primaryInceptionDate, dateHelper.toDateObject(dateList1[0].Date), dateHelper.toDateObject(dateList2[0].Date)]);
            endDate = _.min([inputEndDate, dateHelper.toDateObject(dateList1[dateList1.length - 1].Date), dateHelper.toDateObject(dateList2[dateList2.length - 1].Date)]);
        } else if (dateList1.length > 0 && dateList2.length === 0) {
            startDate = _.max([inputStartDate, primaryInceptionDate, dateHelper.toDateObject(dateList1[0].Date)]);
            endDate = _.min([inputEndDate, dateHelper.toDateObject(dateList1[dateList1.length - 1].Date)]);
        }

        _.each(funds, function(fund) {
            var priceChangePer = getPriceChangePer(fund, data, startDate, endDate);
            priceTableData.push({
                secId: fund.secId,
                name: !fund.currency ? fund.name : fund.name + ' ' + fund.currency,
                startDate: morningstar.asterix.util.date.convertToStandard(startDate),
                endDate: morningstar.asterix.util.date.convertToStandard(endDate),
                priceChangePer: priceChangePer,
                currentPrice: parseFloat(fund.closePrice).toFixed(2),
                inceptionDate: morningstar.asterix.util.date.convertToStandard(fund.inceptionDate),
                asOfDate: asOfDate
            });
        });

        return priceTableData;
    }

    function getPriceChartData(data, chartSettings) {
        var priceChartData = {
            series: []
        };

        var dataList = [];
        _.each([chartSettings.primaryFund, chartSettings.comparisonFund], function(fund) {
            _.each(data, function(item) {
                if (fund.secId === item.Ticker && item.DailyData.HS538.length > 0) {
                    _.each(item.DailyData.HS538, function(i) {
                        dataList.push({
                            date: morningstar.asterix.util.date.convertToStandard(dateHelper.toDateObject(i.Date)),
                            close: Number(i.Last)

                        });
                    });
                    priceChartData.series.push({
                        name: !fund.currency ? fund.name : fund.name + ' ' + fund.currency,
                        data: dataList
                    });
                    dataList = [];
                }
            });
        });

        return priceChartData;
    }

    function getPriceChangePer(fund, data, startDate, endDate) {
        var priceChangePer = 0;
        var priceFirst;
        var priceLast;
        _.each(data, function(item) {
            if (fund.secId === item.Ticker) {
                var dataList = item.DailyData.HS538;
                if (dataList.length > 0) {
                    _.each(dataList, function(i) {
                        if (dateHelper.toDateObject(i.Date) <= startDate) {
                            priceFirst = i.Last;
                        }
                        if (dateHelper.toDateObject(i.Date) <= endDate) {
                            priceLast = i.Last;
                        }
                    });
                    priceChangePer = ((priceLast - priceFirst) / priceFirst * 100).toFixed(2) + '%';
                }
            }
        });
        return priceChangePer;
    }
});


// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/transforms/from-markets.js